import { DEFAULT_CURRENT_PAGE, DEFAULT_ITEMS_PER_PAGE } from "@/config";

const SORT_ENUM = ["amount", "date"]
  .map((field) => [`${field}_ASC`, `${field}_DESC`])
  .flat();

const getSort = (searchParams) => {
  const sortParam = (searchParams.get("sort") || "").toLocaleLowerCase();
  const index = SORT_ENUM.findIndex(
    (value) => value.toLocaleLowerCase() === sortParam,
  );

  return SORT_ENUM[index] || null;
};

export default function getQueryParams(url) {
  const { searchParams } = new URL(url);

  const itemsPerPage =
    Number(searchParams.get("perPage")) || DEFAULT_ITEMS_PER_PAGE;
  const currentPage = Number(searchParams.get("page")) || DEFAULT_CURRENT_PAGE;

  return {
    first: itemsPerPage,
    skip: (currentPage - 1) * itemsPerPage,
    sort: getSort(searchParams),
  };
}
